import InvoiceDocumentFeeItem from './InvoiceDocumentFeeItem.view'

export default InvoiceDocumentFeeItem;